import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[igxCarouselIndicator]'
})
export class IgxCarouselIndicatorDirective {
}

@Directive({
    selector: '[igxCarouselNextButton]'
})
export class IgxCarouselNextButtonDirective {
}

@Directive({
    selector: '[igxCarouselPrevButton]'
})
export class IgxCarouselPrevButtonDirective {
}
